import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../components/Icon';
import { INVEST_SECTORS } from '../mock';

// The approved "OUR INVESTMENT SECTORS" heading + five circular sector icons, used as
// persistent contextual navigation at the bottom of the hero on every Investments page.
const SectorNav = () => {
  const { pathname } = useLocation();

  return (
    <section className="bg-navy" data-testid="sector-nav">
      <div className="dig-container pb-9 pt-7 md:pb-11 md:pt-9">
        <h2 className="investment-sector-nav__title font-serif-dig">OUR INVESTMENT SECTORS</h2>
        <nav className="investment-sector-nav" aria-label="Investment sectors">
          {INVEST_SECTORS.map((s) => {
            const active = pathname === s.to;
            return (
              <Link
                key={s.title}
                to={s.to}
                aria-label={s.title}
                aria-current={active ? 'page' : undefined}
                data-testid={`sector-nav-${s.short.toLowerCase().replace(/ /g, '-')}`}
                className={`investment-sector-link${active ? ' is-active' : ''}`}
              >
                <span className="investment-sector-circle">
                  <Icon name={s.mIcon} strokeWidth={1.4} />
                </span>
                <span className="investment-sector-label">{s.short}</span>
              </Link>
            );
          })}
        </nav>
      </div>
    </section>
  );
};

export default SectorNav;
